// extracted by mini-css-extract-plugin
export default {"root":"ZBKvTI","alignmentWrapper":"ZzGm06"};